//#region IMPORTS
import { InstoreType } from "../../models/instoreType";
import MainTableRowActionDelete from "../_layout/MainTableRowActionDelete";
import InstoreTypesTableRowActionEdit from "./InstoreTypesTableRowActionEdit";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: () => void;
  instoreType: InstoreType;
  editHandler: () => void;
  loading?: boolean;
}
//#endregion

export default function InstoreTypesTableRow({
  deleteHandler,
  instoreType,
  editHandler,
  loading,
}: Props) {
  //#region RENDER
  return (
    <tr className="border-t border-slate-300 h-10">
      {/* read */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        <InstoreTypesTableRowActionEdit
          instoreType={instoreType}
          editHandler={editHandler}
          disabled={loading || instoreType.name.toUpperCase() === "DEFAULT"}
        />
      </td>

      {/* name */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {instoreType.name}
      </td>

      {/* Delete */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        <MainTableRowActionDelete
          deleteHandler={deleteHandler}
          tooltipId={`instoreType${instoreType.id}`}
          disabled={loading}
        />
      </td>
    </tr>
  );
  //#endregion
}
